import type { ToastLike } from '@mangovoice/mango-ui'

import type { HotelsApi } from '../api/hotelsApi'
import { WakeupScheduler } from '../components/wakeup/WakeupScheduler'
import { HotelsI18nProvider } from '../i18n'
import type { HotelsTranslationLike } from '../i18n'
import type { HospitalityPermissions } from '../types/rooms'

interface WakeupSchedulerPageProps {
  api: HotelsApi
  pbxId: number
  pbxUuid: string
  /** IANA PBX timezone (system settings), normalized in the host app. */
  pbxTimeZone: string
  toast: ToastLike
  permissions: HospitalityPermissions
  t?: HotelsTranslationLike
  locale?: string
}

export const WakeupSchedulerPage = ({
  t,
  locale,
  api,
  pbxId,
  pbxUuid,
  pbxTimeZone,
  toast,
  permissions,
}: WakeupSchedulerPageProps) => {
  return (
    <HotelsI18nProvider t={t} locale={locale}>
      <WakeupScheduler
        api={api}
        pbxId={pbxId}
        pbxUuid={pbxUuid}
        pbxTimeZone={pbxTimeZone}
        toast={toast}
        permissions={permissions}
      />
    </HotelsI18nProvider>
  )
}
